export default __webpack_public_path__ + "static/media/fourWalkThumb.6ef0c3da.png";